import { useToast } from './toast';
import { Button, Input, Modal } from './ui';

/** A password Edvora or a school administrator just set, shown once for them to pass on. */
export function TemporaryPasswordNotice({ email, password, onClose }: { email: string; password: string; onClose(): void }) {
  const toast = useToast();
  return (
    <Modal open onClose={onClose} size="sm" title="Temporary password" footer={<Button variant="primary" onClick={onClose}>Done</Button>}>
      <p className="text-sm text-slate-600">
        Share this with <strong>{email}</strong> through a secure channel. It won’t be shown again. They can change it under Settings → My account.
      </p>
      <div className="mt-4 flex gap-2">
        <Input readOnly value={password} className="font-mono" onFocus={(e) => e.target.select()} />
        <Button
          onClick={async () => {
            await navigator.clipboard.writeText(password);
            toast.success('Copied');
          }}
        >
          Copy
        </Button>
      </div>
    </Modal>
  );
}
